import tippy, { sticky } from 'tippy.js'
import { computed, ref, onBeforeUpdate } from 'vue'

export default () => {
  let popup = null
  let emojiRange = null
  let insertEmoji = null

  const navigatedEmojiIndex = ref(0)
  const filteredItems = ref([])
  const emojiQuery = ref(null)
  const emojiRef = ref(null)
  const emojiRefs = ref([])

  const hasResults = computed(() => filteredItems.value.length)
  const showEmoji = computed(() => emojiQuery.value || hasResults.value)

  // to reset the refs before each update
  onBeforeUpdate(() => {
    emojiRefs.value = []
  })

  function onEnter ({ items, query, range, command, virtualNode }) {
    emojiQuery.value = query
    filteredItems.value = items
    emojiRange = range
    renderPopup(virtualNode)
    insertEmoji = command
  }

  function onChange ({ items, query, range, virtualNode }) {
    emojiQuery.value = query
    filteredItems.value = items
    emojiRange = range
    navigatedEmojiIndex.value = 0
    renderPopup(virtualNode)
  }

  function onExit () {
    emojiQuery.value = null
    filteredItems.value = []
    emojiRange = null
    navigatedEmojiIndex.value = 0
    destroyPopup()
  }

  function onKeyDown ({ event }) {
    if (event.key === 'ArrowUp') {
      upHandler()
      emojiRefs.value[navigatedEmojiIndex.value].scrollIntoView(false)
      return true
    }
    if (event.key === 'ArrowDown') {
      downHandler()
      emojiRefs.value[navigatedEmojiIndex.value].scrollIntoView(false)
      return true
    }
    if (event.key === 'Enter') {
      const item = filteredItems.value[navigatedEmojiIndex.value]

      if (item) {
        enterHandler(item)
        return true
      } else {
        return false
      }
    }
    return false
  }

  function onFilter (items, query) {
    if (!query) return items.splice(0, 50)

    return items.filter(item => item.name.toLowerCase().match(query.toLowerCase())).splice(0, 50)
  }
  // navigate to the previous item
  // if it's the first item, navigate to the last one
  function upHandler () {
    navigatedEmojiIndex.value = ((navigatedEmojiIndex.value + filteredItems.value.length) - 1) % filteredItems.value.length
  }
  // navigate to the next item
  // if it's the last item, navigate to the first one
  function downHandler () {
    navigatedEmojiIndex.value = (navigatedEmojiIndex.value + 1) % filteredItems.value.length
  }
  function enterHandler (item) {
    selectEmoji(item)
  }
  // we have to replace our emoji text with a mention
  // so it's important to pass also the position of your emoji text
  function selectEmoji (item, editor) {
    insertEmoji({
      range: emojiRange,
      attrs: { data: item.char }
    })

    if (editor) editor.chain().focus().run()
  }
  // renders a popup with emojiRef
  // tiptap provides a virtualNode object for using popper.js (or tippy.js) for popups
  function renderPopup (node) {
    if (popup) return

    popup = tippy('.editor', {
      getReferenceClientRect: node.getBoundingClientRect,
      appendTo: () => document.body,
      interactive: true,
      sticky: true, // make sure position of tippy is updated when content changes
      plugins: [sticky],
      content: emojiRef.value,
      trigger: 'mouseenter', // manual
      showOnCreate: true,
      theme: 'light',
      placement: 'bottom-start',
      inertia: true,
      duration: [400, 200]
    })
  }

  function destroyPopup () {
    if (popup.length) {
      popup[0].destroy()
      popup = null
    }
  }

  return {
    // data
    navigatedEmojiIndex,
    filteredItems,
    // computeds
    hasResults,
    showEmoji,
    // refs
    emojiRef,
    emojiRefs,
    // funcs
    onEnter,
    onKeyDown,
    onChange,
    onExit,
    onFilter,
    selectEmoji
  }
}
